



















import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
// import {RouteControl} from "@/api/routeControl";
// import {MerchantApi} from "@/api/merchant";
// import i18n from "@/lang/index";
// import {BankAPI} from "@/api/bank";
import BaseDialog from '@/utils/dialog-control'
// import {UtilsIndex} from "@/utils";
import $Api from '@api'
import { translate } from '@/utils/filters'
import { empty } from 'rxjs'
import { cardValidMap, cardStatusMap, cardMap } from '@/utils/status-map'
import { Bank } from '@/api/model/channel'

@Component
export default class extends BaseDialog {
    form = {
        closeTimeStr: '',
        memo: ''
    }

    rules = {
    }

    public update() {
        return empty()
    }

    public create() {
        return empty()
    }

    public onOpen() {
    }

    public onClose() {
    }

    setForm(value) {
        this.form = { ...this.form, ...value }
    }

    confirm() {
        $Api.receiptService.confirmPay(this.form).subscribe(() => {
            this.$emit('confirm')
        }, err => {
            this.$message.error(err.message)
        })
    }
}
